/* ===================== CASCABEL · theme js ===================== */
(function () {
  'use strict';

  /* ---------- menu movil ---------- */
  function initMenu() {
    var b = document.querySelector('[data-burger]');
    var n = document.querySelector('[data-nav]');
    if (!b || !n) return;
    b.addEventListener('click', function () {
      var ab = n.classList.toggle('abierto');
      b.setAttribute('aria-expanded', ab ? 'true' : 'false');
    });
  }

  /* ---------- cuenta regresiva a Navidad ---------- */
  function initCuenta() {
    document.querySelectorAll('[data-cuenta]').forEach(function (box) {
      var meta = box.dataset.cuenta || '';
      var partes = meta.split('-');
      var mes = parseInt(partes[0], 10) || 12;
      var dia = parseInt(partes[1], 10) || 25;

      function pinta() {
        var hoy = new Date();
        var meta = new Date(hoy.getFullYear(), mes - 1, dia, 0, 0, 0);
        if (meta - hoy < 0) meta = new Date(hoy.getFullYear() + 1, mes - 1, dia, 0, 0, 0);
        var ms = meta - hoy;
        var d = Math.floor(ms / 86400000);
        var h = Math.floor((ms % 86400000) / 3600000);
        var m = Math.floor((ms % 3600000) / 60000);
        var set = function (k, v) {
          var el = box.querySelector('[data-c="' + k + '"]');
          if (el) el.textContent = v < 10 ? '0' + v : String(v);
        };
        set('d', d); set('h', h); set('m', m);
      }
      pinta();
      setInterval(pinta, 60000);
    });
  }

  /* ---------- cantidad ---------- */
  function initCantidad() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cant]');
      if (!b) return;
      var caja = b.closest('.cant-caja');
      if (!caja) return;
      var input = caja.querySelector('input');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v = b.dataset.cant === 'mas' ? v + 1 : v - 1;
      input.value = v < 1 ? 1 : v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- galeria + variantes ---------- */
  function leeVariantes(root) {
    var tag = root.querySelector('script[data-variants]') ||
              document.querySelector('script[data-variants]');
    if (!tag) return [];
    try { return JSON.parse(tag.textContent) || []; } catch (e) { return []; }
  }

  function muestraImagen(root, imageId) {
    if (!imageId) return false;
    var target = root.querySelector('.gi[data-img="' + imageId + '"]');
    if (!target) return false;
    root.querySelectorAll('.gi').forEach(function (el) { el.classList.remove('on'); });
    target.classList.add('on');
    root.querySelectorAll('.gal-thumbs button').forEach(function (b) {
      b.classList.toggle('on', b.dataset.img === String(imageId));
    });
    return true;
  }

  function dinero(cents, fmt) {
    var n = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (fmt || '$ {{amount}}').replace('{{amount}}', n).replace('{{amount_no_decimals}}', n);
  }

  function initProducto() {
    document.querySelectorAll('[data-product]').forEach(function (root) {
      var variantes = leeVariantes(root);
      var fmt = root.dataset.money || '$ {{amount}}';
      var idInput = root.querySelector('[name="id"]');

      function seleccionadas() {
        var vals = [];
        root.querySelectorAll('[data-opt]').forEach(function (grupo) {
          var i = grupo.querySelector('input:checked');
          if (i) vals[parseInt(grupo.dataset.opt, 10)] = i.value;
        });
        return vals;
      }

      function buscar(vals) {
        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i], ok = true;
          for (var j = 0; j < vals.length; j++) {
            if (vals[j] !== undefined && v.options[j] !== vals[j]) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function pinta() {
        var v = buscar(seleccionadas());
        if (!v) return;

        if (idInput) idInput.value = v.id;

        var ahora = root.querySelector('[data-precio-ahora]');
        var antes = root.querySelector('[data-precio-antes]');
        var off = root.querySelector('[data-precio-off]');
        if (ahora) ahora.textContent = dinero(v.price, fmt);
        if (antes) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            antes.textContent = dinero(v.compare_at_price, fmt);
            antes.style.display = '';
            if (off) {
              off.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
              off.style.display = '';
            }
          } else {
            antes.style.display = 'none';
            if (off) off.style.display = 'none';
          }
        }

        var btnAdd = root.querySelector('[data-add]');
        var pay = root.querySelector('.shopify-payment-button');
        var noHay = root.querySelector('[data-agotado]');
        if (v.available) {
          if (btnAdd) { btnAdd.removeAttribute('disabled'); btnAdd.style.display = ''; }
          if (pay) pay.style.display = '';
          if (noHay) noHay.style.display = 'none';
        } else {
          if (btnAdd) { btnAdd.setAttribute('disabled', 'disabled'); btnAdd.style.display = 'none'; }
          if (pay) pay.style.display = 'none';
          if (noHay) noHay.style.display = '';
        }

        if (v.featured_image_id) muestraImagen(root, v.featured_image_id);

        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
      }

      root.querySelectorAll('[data-opt] input').forEach(function (i) {
        i.addEventListener('change', pinta);
      });

      root.querySelectorAll('.gal-thumbs button').forEach(function (b) {
        b.addEventListener('click', function () { muestraImagen(root, b.dataset.img); });
      });

      pinta();
    });
  }

  function arranca() {
    initMenu(); initCuenta(); initCantidad(); initProducto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else { arranca(); }

  document.addEventListener('shopify:section:load', arranca);
})();
